<template>
  <div>
    <div class="row hidden-xs"></div>
    <div class="container">
      <div class="row" style="padding-bottom: 80px;">
        <div class="col-xs-12">
          <h2 class="text-primary" v-if="false">Verificação do AR-Online</h2>
          <hr>
          <div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title text-primary">Corpo da mensagem</h3>
              </div>
              <div class="panel-body" v-html="content">
              </div>
            </div>
          </div>
          <div class="" style="margin-bottom: 25px;"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'AppInfoEmailNotSend',

  data () {
    return {
      status: ''
    }
  },

  props: {
    subject: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  mounted () {
    window.jQuery('a[href^="https://spcbrasil.ar-email.com.br/external/"]').remove()
  }

}

</script>
<style>
  body {
    height: 100vh;
  }
  .scroll-top-wrapper.show {
    display: none !important;
  }
  .swal2-container {
    z-index: 99999999;
  }
  @media (max-width:767px){
    .panel-body table * {
      width: 100% !important;
      table-layout: fixed !important;
    }
    .es-wrapper-color{zoom: 50%;}
    .panel-body table a img {
        width: 20px !important;
    }
    img[alt="Carta de Notificação de Regsitro"] {
      height: 180px !important;
    }
    img[alt="Homem feliz"] {
      height: 110px !important;
      width: 130px !important;
    }

    div > div.container-fluid > div:nth-child(2) > div.container > div > div > div:nth-child(3) > div:nth-child(2) > div.panel-body > div > table > tbody > tr > td > table:nth-child(3) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table.es-right > tbody > tr > td > table > tbody > tr > td > p {
      padding-top: 0px;
      padding-right: 0px;
    }
    div > div.container-fluid > div:nth-child(2) > div.container > div > div > div:nth-child(3) > div > div.panel-body > div > table > tbody > tr > td > table:nth-child(2) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(1) > td > table > tbody > tr > td > table > tbody > tr > td > p > strong {
    /* div > div.container-fluid > div.container > div > div > div:nth-child(3) > div:nth-child(2) > div.panel-body > div > table > tbody > tr > td > table:nth-child(2) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(1) strong { */
      overflow-wrap: break-word !important;
    }
    div > div.container-fluid > div:nth-child(2) > div.container > div > div > div:nth-child(3) > div > div.panel-body > div > table > tbody > tr > td > table:nth-child(2) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table > tbody > tr:nth-child(2) > td > table > tbody > tr > td > table > tbody > tr > td > p {
    /* div > div.container-fluid > div.container > div > div > div:nth-child(3) > div:nth-child(2) > div.panel-body > div > table > tbody > tr > td > table:nth-child(2) > tbody > tr > td > table > tbody > tr:nth-child(2) > td > table > tbody p { */
      overflow-wrap: break-word !important;
      font-size: 12px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/InfoEmailNotSend.vue